import { INotification, NotificationAction } from '../../../notifications-interfaces';
import { IStoreProps } from '../../../index';
import { setNotificationsAction } from '../../../data/data-service';
import React, { useState } from 'react';
import Preloader from '../../../../../../ui/svg/common/preloader';
import { useDispatch } from 'react-redux';

interface IClearBtnBtn {
    notification: INotification;
    storeProps: IStoreProps;
}

const ClearBtn = ({ storeProps, notification }: IClearBtnBtn) => {

    const { rootActions } = storeProps;

    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    const onClick = async () => {

        setLoading(true);

        const response = await setNotificationsAction(
            notification.userNTFGUID,
            NotificationAction.Clear,
        );

        setLoading(false);

        if(!response || response.statusCode !== 200) return;

        const count = response.data?.count || 0;
        const notifications = response.data?.notifications || [];

        dispatch(
            rootActions.main({
                count,
                notifications,
                additionalOpenedMenuNotification: null,
                additionalOpenedMenuStyles: null,
            })
        );
    };

    return (
        <>
            {
                loading &&
                <Preloader width="15px" height="15px" color="#4f4f4f" />
            }

            {
                !loading &&
                <button
                    className="px-4 text-left"
                    onClick={ onClick }
                    type="button">
                    Clear
                </button>
            }
        </>
    )
};

export default ClearBtn;